module.exports = __webpack_public_path__ + "static/Compute-Software-Security-Framework-f75ebb27e5ff2732e6ebc5951a89be49.pdf";